export default {
      id: "gb-wls-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "assets/flags-sprite.svg#gb-wls",
      toString: function () {
        return this.url;
      }
    }